import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { AppConstants } from '../../app.constants';
import { AuthDataInterface } from '../models/view-models/account-models/auth-data.interface';

@Injectable()
export class LoginGuard  {
  constructor(private readonly router: Router) {}

  canActivate(): boolean {
    const authData: AuthDataInterface = JSON.parse(
      localStorage.getItem(AppConstants.AUTH_DATA_NAME)
    );

    if (authData) {
      this.router.navigate(['/']);
      return false;
    }
    return true;
  }
}
